"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var setMailboxJunkEmailConfigurationOperation_1 = require("owa-service/lib/operation/setMailboxJunkEmailConfigurationOperation");
var ServiceRequestUtils_1 = require("owa-service/lib/ServiceRequestUtils");
function saveMailboxJunkEmailConfiguration(options) {
    return setMailboxJunkEmailConfigurationOperation_1.default({
        Header: ServiceRequestUtils_1.getJsonRequestHeader(),
        Options: options,
    });
}
exports.default = saveMailboxJunkEmailConfiguration;
//# sourceMappingURL=setMailboxJunkEmailConfiguration.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/data/owa-junkmail-configuration/lib/services/setMailboxJunkEmailConfiguration.js
// module id = 5019
// module chunks = 2